<template>
	<div class="header-div">
		<div>
			<img class="header-left" :src="logoUrl" @click="goHome" />
		</div>
		<div class="header-right">
			<!-- <img class="header-right-icon" src="@/assets/image/person_icon.svg" /> -->
			<client-only>
				<div class="header-right-item" v-if="isShowLogin" @click="showLoginFun">
					{{ $t('home.denglu') }}
				</div>
				<div class="header-right-active" v-if="isShowMyBooking">
					<img class="header-right-item-person" @click="handleGetPersonImg" src="@/assets/image/person.svg" alt="" />
					<div class="header-right-item-book" @click="judgeLogin">{{ $t('home.wodeyuding') }}</div>
				</div>
			</client-only>
			<div class="header-right-item" @click="goFaq">{{ $t('home.kehuzhiyuan') }}</div>
			<client-only>
				<a-popover placement="bottom" overlayClassName="my-popover-fixed-bottom" trigger="click" v-model:visible="showLanguageSelect">
					<template #content>
						<p @click="setLanguage('English', 'En')" data-code="English" class="language_en" :class="language === 'English' ? 'active' : ''">English</p>
						<!-- <p class="language_en" @click="setLanguage('简体中文', 'Cn')" :class="language === '简体中文' ? 'active' : ''" data-code="简体中文">简体中文</p>
						<p class="language_en" @click="setLanguage('繁体中文', 'Hk')" :class="language === '繁体中文' ? 'active' : ''" data-code="繁体中文">繁体中文</p> -->
						<!-- <p class="language_en" @click="setLanguage('日本語', 'Ja')" :class="language === '日本語' ? 'active' : ''" data-code="日本語">日本語</p> -->
						<p class="language_en" @click="setLanguage('Bahasa Indonesia', 'Id')" :class="language === 'Bahasa Indonesia' ? 'active' : ''" data-code="Bahasa Indonesia">Bahasa Indonesia</p>
					</template>
					<template #title>
						<span>{{ $t('home.yuyan') }}</span>
					</template>
					<div v-if="isShowLanguage" class="header-right-item withContent">
						{{ language }}
						<img src="@/assets/image/arrow.svg" />
					</div>
				</a-popover>
			</client-only>
			<client-only>
				<a-popover placement="bottomRight" overlayClassName="my-popover-fixed-bottom" trigger="click" v-model:visible="showCurrencySelect">
					<template #content>
						<p v-for="(item, index) in currencyList" class="set_currency" :class="currency === item ? 'active' : ''" @click="setCurrency(item)" :key="index">
							{{ item }}
						</p>
					</template>
					<template #title>
						<span>{{ $t('home.bizhong') }}</span>
					</template>

					<div v-if="isShowLanguage" class="header-right-item withContent">
						{{ currency }}
						<img src="@/assets/image/arrow.svg" />
					</div>
				</a-popover>
			</client-only>
		</div>
		<a-modal v-model:visible="visible" :title="$t('login.dengru')" width="418px" :footer="null">
			<div class="login-content">
				<h3 class="login-content-tip">{{ $t('login.denglutishi') }}</h3>
				<p class="login-content-des">{{ $t('login.meiyouzhanghu') }}</p>
				<!-- <div class="login-content-facebook fb-login-button" @click="checkLoginState">
          <img class="login-content-facebook-icon" src="@/assets/image/invalid-name.png" alt="" />
          <span>{{ $t('login.shiyongfacebookdengru') }}</span>
        </div> -->
				<div class="account-login">
					<!-- <div class="account-login-line">
            <span>{{ $t('login.huo') }}</span>
          </div> -->
					<div class="passenger-edit-div" style="position: relative">
						<div class="edit-item">
							<p class="edit-item-label">{{ $t('login.zhanghao') }}</p>
							<a-input class="edit-item-input" v-model:value="account" :placeholder="$t('addPsg.qingshuru') + $t('login.dianziyoujian')" @input="clearError(0)"></a-input>
							<p class="edit-item-error" style="bottom: -12px" v-if="accountError">{{ $t('addPsg.qingshuru') }} {{ $t('login.zhanghao') }}</p>
						</div>
					</div>
					<div class="passenger-edit-div" style="position: relative">
						<div class="edit-item">
							<p class="edit-item-label">{{ $t('login.mima') }}</p>
							<a-form>
								<a-input-password class="edit-item-input" v-model:value="password" @input="clearError(1)" autocomplete="off" :placeholder="$t('login.mima')"></a-input-password>
							</a-form>
							<p class="edit-item-error" style="bottom: -12px" v-if="passwordError">{{ $t('addPsg.qingshuru') }}{{ $t('login.mima') }}</p>
						</div>
					</div>
				</div>
				<h3 class="account-register">
					<span @click="immediaRegister">{{ $t('login.lijizhuce') }}</span>
				</h3>
				<div style="text-align: center">
					<span class="login-btn" @click="goLogin">{{ $t('login.dengru') }}</span>
				</div>
				<div class="login-guest" @click="guestLogin" v-if="!piniaStore.getToken">
					{{ $t('login.yikerenshenfen') }}
				</div>
			</div>
		</a-modal>
		<a-modal v-model:visible="showRegister" width="800px" :title="$t('login.zhuce')" :footer="null">
			<div class="passenger-edit-content register-edit">
				<div class="passenger-gender-outer-div">
					<div class="gender-main-div">
						<span class="gender-input-label gender-bottom">{{ $t('addPsg.xingbie') }}<i>*</i></span>
						<p :class="formData.gender == 'M' ? 'gender-input-item active' : 'gender-input-item'" @click="setGender('M')">
							<span></span>
							{{ $t('addPsg.nan') }}
						</p>
						<p :class="formData.gender == 'F' ? 'gender-input-item active' : 'gender-input-item'" @click="setGender('F')">
							<span></span>
							{{ $t('addPsg.nv') }}
						</p>
					</div>
					<p class="edit-item-error" v-if="formData.genderError">{{ $t('addPsg.qingxuanze') }} {{ $t('addPsg.xingbie') }}</p>
				</div>
				<div class="passenger-edit-div middle">
					<div class="edit-item" style="width: 365px">
						<p class="edit-item-label">{{ $t('addPsg.xingshi') }}<i>*</i></p>
						<a-input class="edit-item-input" v-model:value="formData.familyName" :placeholder="$t('addPsg.qingshuru') + $t('addPsg.xingshi')" @input="clearError(2)"></a-input>
						<p class="edit-item-error active" v-if="formData.familyNameError">{{ $t('addPsg.qingshuru') }} {{ $t('addPsg.xingshi') }}</p>
					</div>
					<div class="edit-item" style="width: 365px">
						<p class="edit-item-label">{{ $t('addPsg.mingzi') }}<i>*</i></p>
						<a-input class="edit-item-input" :placeholder="$t('addPsg.qingshuru') + $t('addPsg.mingzi')" v-model:value="formData.givenName" @input="clearError(3)"></a-input>
						<p class="edit-item-error active" v-if="formData.givenNameError">{{ $t('addPsg.qingshuru') }}{{ $t('addPsg.mingzi') }}</p>
					</div>
				</div>
				<div class="passenger-edit-div middle">
					<div class="edit-item" style="width: 365px">
						<p class="edit-item-label">{{ $t('login.zhanghao') }}<i>*</i></p>
						<a-input class="edit-item-input" v-model:value="formData.account" :placeholder="$t('addPsg.qingshuru') + $t('login.dianziyoujian')" @input="clearError(4)"></a-input>
						<p class="edit-item-error active" v-if="formData.accountError">{{ $t('addPsg.qingshuru') }} {{ $t('login.zhanghao') }}</p>
					</div>
					<div class="edit-item" style="width: 365px">
						<p class="edit-item-label">{{ $t('login.yanzhengzhanghao') }}<i>*</i></p>
						<a-input class="edit-item-input" v-model:value="formData.repeatAccount" :placeholder="$t('addPsg.qingshuru') + $t('login.dianziyoujian')" @input="clearError(5)"></a-input>
						<p class="edit-item-error active" v-if="formData.repeatAccountError">{{ $t('addPsg.qingshuru') }}{{ $t('login.zhanghao') }}</p>
						<p class="edit-item-error active" v-if="formData.repeatAccountErrors">{{ $t('login.zhanghao') }}{{ $t('login.buyizhi') }}</p>
					</div>
				</div>
				<div class="passenger-edit-div middle register-form">
					<div class="edit-item" style="width: 365px">
						<p class="edit-item-label">{{ $t('login.mima') }}<i>*</i></p>
						<a-form>
							<a-input-password
								class="edit-item-input"
								v-model:value="formData.password"
								autocomplete="off"
								:placeholder="$t('addPsg.qingshuru') + $t('login.mima')"
								@input="clearError(6)"
							></a-input-password>
						</a-form>
						<p class="edit-item-error active" v-if="formData.passwordError">{{ $t('addPsg.qingshuru') }} {{ $t('login.mima') }}</p>
					</div>
					<div class="edit-item" style="width: 365px">
						<p class="edit-item-label">{{ $t('login.yanzhengmima') }}<i>*</i></p>
						<a-form>
							<a-input-password
								class="edit-item-input"
								autocomplete="off"
								v-model:value="formData.repeatPassword"
								:placeholder="$t('addPsg.qingshuru') + $t('login.mima')"
								@input="clearError(7)"
							></a-input-password>
						</a-form>
						<p class="edit-item-error active" v-if="formData.repeatPasswordError">{{ $t('addPsg.qingshuru') }}{{ $t('login.mima') }}</p>
						<p class="edit-item-error active" v-if="formData.repeatPasswordErrors">{{ $t('login.mima') }}{{ $t('login.buyizhi') }}</p>
					</div>
				</div>
				<h3 class="account-register" style="width: 100%">
					<span @click="immediaLogin">{{ $t('login.lijidenglu') }}</span>
				</h3>
				<div style="text-align: center">
					<span class="login-btn" style="width: 360px" @click="goRegister">{{ $t('login.zhuce') }}</span>
				</div>
			</div>
		</a-modal>
	</div>
</template>
<script lang="ts">
import { ApiFacebookLogin, ApiGuestLogin, ApiMemberLogin, ApiMemberRegister } from '~/api/login';
import myStorage from '~/utils/storage';
import { Modal, message } from 'ant-design-vue';
import { getCurrentInstance, onMounted, ref, watch, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { store } from '@/store/index';
import pinia from '@/store/store';
import { storeToRefs } from 'pinia';
import FB from 'fb-sdk';
// FB.init({
//   appId: "919555799162149", //facebook申请的的appid
//   autoLogAppEvents: true,
//   cookie: true, // enable cookies to allow the server to access
//   xfbml: true, // parse social plugins on this page
//   version: "v16.0", // use graph api version 2.8
// });
import { useRouter, useRoute } from 'vue-router';
export default {
	setup() {
		const {
			appContext: {
				config: { globalProperties },
			},
		} = getCurrentInstance();
		const { locale } = useI18n();
		const localeRoute = useLocaleRoute();
		const piniaStore = store(pinia);
		let { getCurrencyList, getCurrency } = storeToRefs(piniaStore);
		const formData = reactive({
			gender: 'M',
			genderError: false,
			familyName: '',
			familyNameError: false,
			givenName: '',
			givenNameError: false,
			account: '',
			accountError: false,
			repeatAccount: '',
			repeatAccountError: false,
			repeatAccountErrors: false,
			password: '',
			passwordError: false,
			repeatPassword: '',
			repeatPasswordError: false,
			repeatPasswordErrors: false,
		});
		const isClickNext = ref('');
		const router = useRouter();
		const isShowLanguage = computed(() => {
			return router.currentRoute.value.meta.isShowLanguage;
		});
		const currency = computed(() => {
			return getCurrency.value;
		});
		const currencyList = computed(() => {
			return getCurrencyList.value;
		});
		const route = useRoute();
		const logoUrl = ref('');
		const goVisible = ref(true);
		let language = ref<string>('');

		let showLanguageSelect = ref<boolean>(false);
		let showCurrencySelect = ref<boolean>(false);
		let accountError = ref<boolean>(false);
		let passwordError = ref<boolean>(false);
		const emailInfo = ref('');
		const username = ref('');
		let visible = ref<boolean>(false);
		const showRegister = ref<boolean>(false);
		let account = ref<string>('');
		const isShowLogin = ref(true);
		let isShowMyBooking = ref(false);
		let password = ref<string>('');
		function showLoginFun() {
			visible.value = true;
		}
		globalProperties.$Bus.on('loginGuest', (val: string) => {
			isClickNext.value = val;
			visible.value = true;
		});
		function setLanguage(code: string, code2: string) {
			language.value = code;
			showLanguageSelect.value = false;
			locale.value = code2;
			piniaStore.setLang(code2);
			const pathName = route.path.substring(4);
			const routePath = localeRoute({ path: '/' + code2 + '/' + pathName, query: { ...route.query } });
			if (routePath) {
				navigateTo(routePath.fullPath); // 路由跳转
			}
			setTimeout(() => {
				window.location.reload();
			}, 400);
		}
		if (route.query.cid && route.query.language && route.query.currency) {
			piniaStore.setLang(route.query.language as string);
			piniaStore.setCurrency(route.query.language as string);
		} else {
			if (!piniaStore.getLang) {
				piniaStore.setLang('En');
			}
		}

		function setCurrency(code: string) {
			currency.value = code;
			showCurrencySelect.value = false;
			piniaStore.setCurrency(code);
			myStorage.setStore('currency', code);
		}
		function handleGetPersonImg() {
			if (piniaStore.getUserInfo.uid != -1) {
				const routePath = localeRoute({
					path: '/myAccount',
				});
				if (routePath) {
					return navigateTo(routePath.fullPath); // 路由跳转
				}
			}
		}
		function goHome() {
			const routePath = localeRoute({
				path: '/',
			});
			if (routePath) {
				return navigateTo(routePath.fullPath + '/'); // 路由跳转
			}
		}
		function goFaq() {
			const routePath = localeRoute({
				path: '/commonProblem',
			});
			if (routePath) {
				return navigateTo(routePath.fullPath); // 路由跳转
			}
		}
		function immediaRegister() {
			visible.value = false;
			showRegister.value = true;
		}
		function immediaLogin() {
			visible.value = true;
			showRegister.value = false;
		}
		function goRegister() {
			let haveError = false;
			if (!formData.familyName) {
				haveError = true;
				formData.familyNameError = true;
			}
			if (!formData.givenName) {
				haveError = true;
				formData.givenNameError = true;
			}
			if (!formData.account) {
				haveError = true;
				formData.accountError = true;
			}
			if (!formData.repeatAccount) {
				haveError = true;
				formData.repeatAccountError = true;
			}
			if (formData.repeatAccount) {
				if (formData.account !== formData.repeatAccount) {
					haveError = true;
					formData.repeatAccountError = false;
					formData.repeatAccountErrors = true;
				}
			}
			if (!formData.password) {
				haveError = true;
				formData.passwordError = true;
			}
			if (!formData.repeatPassword) {
				haveError = true;
				formData.repeatPasswordError = true;
			}
			if (formData.repeatPassword) {
				if (formData.password !== formData.repeatPassword) {
					haveError = true;
					formData.repeatPasswordError = false;
					formData.repeatPasswordErrors = true;
				}
			}
			if (haveError) {
				return false;
			}
			let postData = {
				gender: formData.gender,
				firstName: formData.familyName,
				lastName: formData.givenName,
				email: formData.account,
				password: formData.password,
			};
			ApiMemberRegister(postData).then((res: any) => {
				if (res.status === 0) {
					let { email, uname } = res.data;
					emailInfo.value = email;
					username.value = uname;
					formData.gender = 'M';
					formData.familyName = '';
					formData.givenName = '';
					formData.account = '';
					formData.repeatAccount = '';
					formData.password = '';
					formData.repeatPassword = '';
					if (email) {
						showRegister.value = false;
					}
					countDown();
				} else {
					message.error(globalProperties.$t('login.zhuceshibai'));
				}
			});
		}
		const countDown = () => {
			Modal.success({
				title: () => globalProperties.$t('login.zhucechenggong'),
				content: () => h('div', {}, [h('p', globalProperties.$t('login.zhanghao') + ':' + emailInfo.value)]),
				okText: globalProperties.$t('login.qudenglu'),
				onOk: () => {
					goLoginDialog();
				},
			});
		};
		function goLoginDialog() {
			visible.value = true;
		}
		function goLogin() {
			let haveError = false;
			if (!account.value) {
				haveError = true;
				accountError.value = true;
			}
			if (!password.value) {
				haveError = true;
				passwordError.value = true;
			}
			if (haveError) {
				return false;
			}
			let postData = {
				email: account.value,
				password: password.value,
			};
			ApiMemberLogin(postData).then((res: any) => {
				if (res.status == 0) {
					let { token, uid, uname } = res.data;
					visible.value = false;
					piniaStore.setToken(token);
					piniaStore.setUserInfo({ uid: uid, uname: uname });
					piniaStore.setIsLogin(true);
					account.value = '';
					password.value = '';
					visible.value = false;
					setTimeout(() => {
						if (isClickNext.value) {
							const routePath = localeRoute({
								path: '/addPassenger',
							});
							if (routePath) {
								return navigateTo(routePath.fullPath); // 路由跳转
							}
						}
					}, 0);
				} else {
					message.error(globalProperties.$t('login.denglushibai'));
				}
			});
		}
		function guestLogin() {
			ApiGuestLogin().then((res: any) => {
				visible.value = false;
				let { token, uid, uname } = res;
				piniaStore.setToken(token);
				piniaStore.setUserInfo({ uid: uid, uname: uname });
				piniaStore.setIsLogin(true);
				if (isClickNext.value) {
					const routePath = localeRoute({
						path: '/addPassenger',
					});
					if (routePath) {
						return navigateTo(routePath.fullPath); // 路由跳转
					}
				}
			});
		}
		function clearError(type: number) {
			if (type == 0) {
				accountError.value = false;
			} else if (type == 1) {
				passwordError.value = false;
			} else if (type == 2) {
				formData.familyNameError = false;
			} else if (type == 3) {
				formData.givenNameError = false;
			} else if (type == 4) {
				formData.accountError = false;
			} else if (type == 5) {
				formData.repeatAccountError = false;
				if (formData.account === formData.repeatAccount) {
					formData.repeatAccountError = false;
				} else {
					formData.repeatAccountError = true;
				}
			} else if (type == 6) {
				formData.passwordError = false;
			} else if (type == 7) {
				formData.repeatPasswordError = false;
				if (formData.password === formData.repeatPassword) {
					formData.repeatPasswordErrors = false;
				} else {
					formData.repeatPasswordErrors = true;
				}
			}
		}
		function judgeLogin() {
			const routePath = localeRoute({
				path: '/myBooking',
			});
			if (routePath) {
				return navigateTo(routePath.fullPath); // 路由跳转
			}
			// if (piniaStore.getToken) {

			// } else {
			//   visible.value = true
			// }
		}

		function checkLoginState() {
			// 检测FB登录状态
			FB.getLoginStatus(function (response) {
				if (response.status === 'connected') {
					// 已登录
					loginApi(response);
				} else {
					FB.login(function (res) {
						if (res.status === 'connected') {
							loginApi(res);
						} else {
							message.error(globalProperties.$t('login.denglushibai'));
						}
					});
				}
			});
		}
		function setGender(sex: string) {
			formData.gender = sex;
		}
		function loginApi(res: any) {
			let { accessToken, userID } = res.authResponse;
			let params = {
				accessToken: accessToken,
				userId: userID,
				type: 'facebook',
				cid: piniaStore.getChannelCid,
			};
			ApiFacebookLogin(params).then((data: any) => {
				let { token, uid, uname } = data;
				piniaStore.setToken(token);
				piniaStore.setUserInfo({ uid: uid, uname: uname });
				piniaStore.setIsLogin(true);
				visible.value = false;
				if (isClickNext.value) {
					const routePath = localeRoute({
						path: '/addPassenger',
					});
					if (routePath) {
						return navigateTo(routePath.fullPath); // 路由跳转
					}
				}
			});
		}

		onMounted(() => {
			setCurrency(getCurrency.value);
			// loadSdk()
			// chatwoot支持语言参考：https://github.com/chatwoot/chatwoot/tree/develop/app/javascript/dashboard/i18n/locale/zh_CN
			const localLanguage: string = myStorage.getStore('lang') || 'En';
			if (localLanguage == 'Cn') {
				language.value = '简体中文';
			}
			if (localLanguage == 'En') {
				language.value = 'English';
			}
			if (localLanguage == 'Hk') {
				language.value = '繁体中文';
			}
			if (localLanguage == 'Id') {
				language.value = 'Bahasa Indonesia';
			}
			if (localLanguage == 'Ja') {
				language.value = '日本語';
			}
			if (piniaStore.getContent) {
				logoUrl.value = piniaStore.getContent.logo;
			}
			// piniaStore.setToken(
			//   'EAANEVMTCnSUBO0oFNZC5UwZBzBqDAvHMvfVjcpxeenZAYI9s3C5RrJ2jZADrffiqkrp7fsQXPp2CUpCd21xMjE3FD8g3dlQtHGZBDZAoNGonmWE2M8XJryL4xUV3HCIg1jOdlCTXZB5JkbZAunhWVdEVcuq8x1XXvewBHpFyiIAOZCcITrWUJ5GO9Hd3LAT1jxbFFUaNuFAi5aP5nVAUFAKWYM9lRmHQz'
			// )
			// piniaStore.setUserInfo({ uname: 'lixin', uid: 2 })
			// piniaStore.setIsLogin(true)
		});
		// 监听当前路由当游客登录时候在下单页不展示login以及myBookIng
		watch(
			() => router.currentRoute.value,
			(newValue: any) => {
				if (piniaStore.getUserInfo) {
					if (piniaStore.getUserInfo.uid != -1) {
						isShowLogin.value = false;
						isShowMyBooking.value = true;
					} else {
						isShowMyBooking.value = false;
						if (newValue.meta.isShowLogin) {
							isShowLogin.value = true;
						} else {
							isShowLogin.value = false;
						}
					}
				}
			},
			{ immediate: true, deep: true }
		);
		const subscribe = piniaStore.$subscribe((mutation: any, state: any) => {
			if (state.userInfo) {
				if (state.userInfo.uid != -1) {
					isShowLogin.value = false;
					isShowMyBooking.value = true;
				} else {
					isShowMyBooking.value = false;
					if (router.currentRoute.value.meta.isShowLogin) {
						isShowLogin.value = true;
					} else {
						isShowLogin.value = false;
					}
				}
			} else {
				isShowLogin.value = true;
				isShowMyBooking.value = false;
			}
			if (state.content) {
				logoUrl.value = state.content.logo;
			}
		});
		return {
			judgeLogin,
			clearError,
			goRegister,
			goLogin,
			goVisible,
			visible,
			setGender,
			accountError,
			passwordError,
			account,
			password,
			goFaq,
			showRegister,
			language,
			immediaRegister,
			immediaLogin,
			showLanguageSelect,
			setLanguage,
			setCurrency,
			currency,
			countDown,
			showCurrencySelect,
			goHome,
			showLoginFun,
			checkLoginState,
			handleGetPersonImg,
			logoUrl,
			piniaStore,
			guestLogin,
			isShowLogin,
			isShowMyBooking,
			formData,
			isShowLanguage,
			currencyList,
		};
	},
};
</script>
<style scoped>
@import url('./header.css');
</style>
